define('home/templates/anonHomepage',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div data-role=\"motd-alert\"></div>\n<div data-role=\"marketing-module\"></div>\n<div class=\"relative__wrapper\">\n<div data-role=\"overlay\"></div>\n<div class=\"section-contained-narrow\">\n<div class=\"layout padding-bottom-double\">\n<div class=\"content__wrap\">\n<header class=\"module-header text-center\">\n"
    + ((stack1 = container.invokePartial(partials.channelsHeader,depth0,{"name":"channelsHeader","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</header>\n<div data-role=\"content-area\"></div>\n</div>\n</div>\n</div>\n</div>\n";
},"usePartial":true,"useData":true})

});
